import Announcement from './CMSDisplayComponents/Announcement/Announcement';
import RoleDescriptions from './CMSDisplayComponents/RoleDescriptions/RoleDescriptions';

export const CMS_OBJECT_TYPES = {
	Announcement: {
		name: 'Announcement',
		uiComponent: Announcement,
		fields: {
			Header: 'HeaderTitle',
			Content: 'Content',
			VisibleTo: 'Visible To',
		},
	},
	RoleDescriptions: {
		name: 'App Role Descriptions',
		uiComponent: RoleDescriptions,
		fields: {
			App: 'App',
			AppRoles: 'App Roles',
		},
	},
};

export const CMS_Roles = {
	Admin: {
		Search: 'CMS-Admin',
	},
	User: {
		Search: 'CMS-User',
	},
};

export const CMS_Statuses = {
	Draft: 'Draft',
	PendingApproval: 'PendingApproval',
	Approved: 'Approved',
};
